export enum WebsitePageNamesEnum {
  Default,
  AccountDetails,
  AccountDetails_Advanced,
  AccountDetails_PasswordChange,
  Activate,
  ClickAndCollect_Sites,
  PaymentCards,
  Purses,
  Vouchers,
  LoyaltyPass,
  // public pages
  Login,
  ForgotPassword,
  PrivacyPolicy,
  HelpCentreFAQs,
  SignUp,
}
